import { CustomLink } from "../types";

export enum SubLinkId {}

export const links: CustomLink[] = [
  {
    id: "1",
    text: "Front view",
    title: "Front view",
    hasSublinks: false,
    annotations: ["btn_1"],
    subLinks: [],
  },
  {
    id: "2",
    text: "Side view",
    title: "Side view",
    hasSublinks: false,
    annotations: ["btn_2"],
    subLinks: [],
  },
  {
    id: "3",
    text: "Top view",
    title: "Top view",
    animationSequences: [],
    hasSublinks: false,
    annotations: ["btn_3"],
    subLinks: [],
  },
  {
    id: "4",
    text: "Bag interior",
    title: "Bag interior",
    animationSequences: [],
    hasSublinks: false,
    annotations: ["btn_4"],
    subLinks: [],
  },
];
